import React, { useState, useEffect } from "react"
import "../../styles/Common/DynamicCard.less"
import CircleIcon from "./CircleIcon"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"
import BenefitStore from "../../Configs/Store/benefit"
import FormStore from "../../Configs/Store/forms"
import { DataLayerFn } from "../../Configs/API"
import { scrollToClassHorizon } from "../Common/CommonFunctions"
import Image from "./Image"
import DOMPurify from "dompurify"

const DynamicCard = observer((props) => {
  const device = AppStore.device
  // const cardInModal = useStoreState((state) => state.benifitsCard.modalMode)
  const detailedMode = BenefitStore.detailedMode
  const setDetailedMode = BenefitStore.setDetailedMode
  const [cardCollapsed, setCollapsed] = useState(true)
  const [addEventExpand, setAddEventExpand] = useState(false) // Fund Performance Event
  const [addEventModal, setAddEventModal] = useState(false) // Fund Performance Grid Modal Event

  useEffect(() => {
    if (detailedMode && !addEventExpand) {
      setTimeout(addEventForFPExpand, 1000) // triggers addEventForFPExpand after 1s if detailedMode state changes
    }
  }, [detailedMode])

  useEffect(() => {
    if (BenefitStore.modalMode && !addEventModal) {
      setTimeout(addEventForFPModal, 1000) // triggers addEventForFPModal after 1s if modalMode state changes
    }
  }, [BenefitStore.modalMode])

  const scrollToFP = () => { // func to scroll to targeted element
    console.info("Scroll FpRoot")
    BenefitStore.setModalMode(false)
    scrollToClassHorizon("FpRoot")
  }

  const addEventForFPExpand = () => {
    // var elements = document.querySelector(".IncomeRoot .KeyBenHYPFP")
    // elements.addEventListener("click", scrollToFP, false)
    // setAddEventExpand(true)
  }

  const addEventForFPModal = () => {
    // var elements = document.querySelector(".BenefitPCModalRoot .KeyBenHYPFP")
    // elements.addEventListener("click", scrollToFP, false)
    // setAddEventModal(true)
  }

  let wrapper = props.wrapperStyle
  let titleBodyWrapper = props.titleBodyWrapperStyle
  let title = props.titleStyle
  let content = props.contentStyle
  let dot = props.dotStyle
  let arrowUrl = props.arrowUrl
  let arrowStyle = props.arrowStyle
  let icon = props.iconStyle
  let forDataLayer = props.dataLayerEvent

  if (device === 1) {
    if (detailedMode) {
      if (cardCollapsed && props.expandable) {
        wrapper = "HideCard"
      } else if (props.expandable) {
        wrapper = "DynamicCardPCWrapperExpanded"
        title = "DynamicCardTitlePCExpanded"
        arrowStyle = "arrowPCsmExpand"
      }
    }
  }

  const handleExpand = async () => {
    var eventName = forDataLayer.split("|")[0]
    var optionText = forDataLayer.split("|")[1]
    if (cardCollapsed) {
      DataLayerFn(eventName + "||Calculator-Landing page|Benefits", FormStore, "", "", optionText, "")
    }
    if (!detailedMode) {
      await setDetailedMode(true)
      setCollapsed(false)
      // DataLayerFn("PlanBenefits_PopupOpen||Calculator-Landing page|Plan Benefits", FormStore, "", "", optionText, "")
    }
  }
  const handleCollapse = async () => {
    var eventName = forDataLayer.split("|")[0]
    var optionText = forDataLayer.split("|")[1]
    if (detailedMode) {
      setCollapsed(true)
      await setDetailedMode(false)
      // DataLayerFn(eventName+"||Calculator-Landing page|Plan Benefits", FormStore, "", "", optionText, "")
    }
  }

  useEffect(() => {
    BenefitStore.modalMode && handleCollapse()
  }, [BenefitStore.modalMode])
  // const myRef = useRef(null)

  // useEffect(() => {
  //   console.log(props.key)
  //   //
  //   myRef.current?.scrollIntoView({
  //     behavior: "auto",
  //     block: "center",
  //     inline: "center",
  //   })
  // })
  return (
    <div
      style={props.style ? { ...props.style } : {}}
      className={props.className ? props.className + " " + wrapper : wrapper}
      onClick={props.expandable && device === 1 ? handleExpand : props.onClick}
    >
      {props.iswhyus ? ( // if cards for whys us section
        <div className="cardwhyus">
          <div className="iconCrossWrap">
            {props.dot ? ( // for card icon
              <div className={dot}>
                {props.icon ? (
                  // <img className={icon} src={`assets/${props.data.iconId}.svg`} />
                  <CircleIcon
                    iconStyle={icon}
                    iconUrl={props.data.iconId}
                    imgheight={AppStore.device === 1 ? props.imgheight1 : props.imgheight0}
                    imgwidth={AppStore.device === 1 ? props.imgwidth1 : props.imgwidth0}
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
            {props.cross ? <CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} onClick={props.crossOnClick} /> : ""}
          </div>
          <div className={titleBodyWrapper}>
            {props.title ? <div className={title} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.title) }}></div> : ""}

            {detailedMode || props.content ? <div className={content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.content?.replace(/\{\{fundCount\}\}/g, `${FormStore.api_fundCount}`)) }}></div> : ""}

            {props.customComp}
          </div>
          {/* {props.arrow ? <img src={`assets/${arrowUrl}.svg`} className={arrowStyle} alt={""} onClick={handleCollapse}></img> : ""} */}
          {props.arrow ? <Image src={arrowUrl} className={arrowStyle} alt={""} onClick={handleCollapse}></Image> : ""} 
        </div>
      ) : (
        <>
          <div className="iconCrossWrap">
            {props.dot ? (
              <div className={dot}>
                {props.icon ? (
                  // <img className={icon} src={props.data.iconId} />
                  <CircleIcon
                    imgheight={AppStore.device === 1 ? (props.imgheight1 ? props.imgheight1 : props.imgheight) : props.imgheight0 ? props.imgheight0 : props.imgheight}
                    imgwidth={AppStore.device === 1 ? (props.imgwidth1 ? props.imgwidth1 : props.imgwidth) : props.imgwidth0 ? props.imgwidth0 : props.imgwidth}
                    iconStyle={icon}
                    iconUrl={props.data.iconId}
                    imgalt={props.imgalt}
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
            {props.cross ? <CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} onClick={props.crossOnClick} /> : ""}
          </div>
          <div className={titleBodyWrapper}>
            {props.title ? <div className={title} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.title) }}></div> : ""}

            {detailedMode || props.content ? <div className={content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.content?.replace(/\{\{fundCount\}\}/g, `${FormStore.api_fundCount}`)) }}></div> : ""}

            {props.customComp}
          </div>
          {/* {props.arrow && arrowUrl ? <img src={`assets/${arrowUrl}.svg`} className={arrowStyle} alt={props.arrowalt} width={props.arrowimgwidth} height={props.arrowimgheight} onClick={handleCollapse}></img> : ""} */}
          {props.arrow && arrowUrl ? <Image src={arrowUrl} className={arrowStyle} alt={props.arrowalt} width={props.arrowimgwidth} height={props.arrowimgheight} onClick={handleCollapse}></Image> : ""}
        </>
      )}
    </div>
  )
})

export default DynamicCard
